export const ProjectPreviewSkeleton = () => {
  return (
    <div className="w-full relative height-[0px] pt-[100%] sm:rounded-[4px] overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-full bg-bg-1"></div>
    </div>
  )
}
